
const saleCalculator = require('../../../sales/saleCalculator');
const constants = require('../../../constants');

module.exports.isSaleEndorsementApplicable = function(sale, integration)
{
    if (sale.saleType !== constants.SaleTypeSale ||
        sale.venueCode !== constants.VenueCodeProperty ||
        !saleCalculator.isSaleFullyPaid(sale) ||
        saleCalculator.isSaleFullyRefunded(sale))
        return false;

    const existingEndorsements = sale.endorsements.filter(e =>
                                      e.integrationType === integration.integrationType && e.externalEntity === integration.externalEntity);

    if (existingEndorsements.length > 0)
        return false;

    return true;
}